// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"f8-z"};